import _ from "lodash"
import { useContext, useEffect } from "react"

import { useFormikContext } from "formik"

import styles from "../../../styles/Form.module.css"
import { FormContext } from "../../../context/formContext"

export default function EightAssesmentScore({ field, block, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const totalSumOfAssessmentValues = _.reduce(
      formik.values,
      (acc, value, key) => {
        const pattern = /\d_/
        const isAssessmentField = pattern.test(key)
        return isAssessmentField ? acc + Number(value) : acc
      },
      0
    )

    if (formik.values[field.field_name] !== totalSumOfAssessmentValues) {
      formik.setFieldValue(field.field_name, totalSumOfAssessmentValues)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
